export default "__VITE_PUBLIC_ASSET__baa1ece3__"